/** Encode each path segment for use in a URL path after /api/doc/ */
export function encodeDocPath(rel: string): string {
  return rel
    .split('/')
    .filter(Boolean)
    .map((s) => encodeURIComponent(s))
    .join('/')
}

export function posixDir(p: string): string {
  const i = p.lastIndexOf('/')
  return i <= 0 ? '' : p.slice(0, i)
}

/**
 * Resolve a relative href from a markdown file path (POSIX, forward slashes).
 */
export function resolveMdHref(currentDocPath: string, href: string): string | null {
  const raw = href.trim().split('#')[0].split('?')[0]
  if (!raw || /^https?:\/\//i.test(raw) || raw.startsWith('mailto:')) return null

  const base = posixDir(currentDocPath)
  const segments = raw.split('/')
  const stack = base ? base.split('/').filter(Boolean) : []
  for (const seg of segments) {
    if (seg === '' || seg === '.') continue
    if (seg === '..') {
      stack.pop()
      continue
    }
    stack.push(seg)
  }
  const out = stack.join('/')
  if (out.startsWith('..')) return null
  return out
}
